import { datadogRum } from '@datadog/browser-rum';

const getVitalTypeFactory = ({ key, desc }: { key: string; desc: string }) => {
  return {
    key,
    desc,
    start: async () => {
      // const ddConfig = getDatadogConfig();
      // const datadogRum = getDataDogLib(!!ddConfig);
      if (datadogRum) {
        // console.log(`Starting Vital ${key}`);
        datadogRum.startDurationVital(key, {
          context: {
            advertType: `[Start]: ${key}`,
          },
          description: desc,
        });
      }
    },
    stop: async () => {
      // const ddConfig = getDatadogConfig();
      // const datadogRum = getDataDogLib(!!ddConfig);
      if (datadogRum) {
        // console.log(`Stopping Vital ${key}`);
        datadogRum.stopDurationVital(key, {
          context: {
            advertType: `[Stop]: ${key}`,
          },
          description: desc,
        });
      }
    },
  };
};

export const DataDogVitals = {
  InitLoad: getVitalTypeFactory({
    key: 'init-load',
    desc: 'initial page load to path update',
  }),
  /** Advert Dom Present and Request Made For Ad To Be Populated On First Site Load */
  AdDomBannerInit: getVitalTypeFactory({
    key: 'ad-dom-banner-inital',
    desc: 'Advert Dom Present and Request Made For Ad To Be Populated On First Page Load Finish',
  }),
  /** Advert Dom Present and Request Made For Ad To Be Populated On Navigation */
  AdDomBannerNav: getVitalTypeFactory({
    key: 'ad-dom-banner-navigate',
    desc: 'Advert Dom Present and Request Made For Ad To Be Populated On Navigation',
  }),

  /** Banner Ad Request Made > Banner Ad Request Fulfilled */
  AdBannerResponse: getVitalTypeFactory({
    key: 'ad-banner-response',
    desc: 'Banner Ad Request Made > Banner Ad Request Fulfilled',
  }),
  // 'PayloadReponse' = 'payload-response',
};
